import { css } from '@xstyled/styled-components'

export const fontFaces = css``
